import { render } from "./FoodMenuCreateContainer.vue?vue&type=template&id=23a97e6e&scoped=true&ts=true"
import script from "./FoodMenuCreateContainer.vue?vue&type=script&lang=ts"
export * from "./FoodMenuCreateContainer.vue?vue&type=script&lang=ts"

import "./FoodMenuCreateContainer.vue?vue&type=style&index=0&id=23a97e6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a97e6e"]])

export default __exports__